import { render, staticRenderFns } from "./NewDBGComponent.vue?vue&type=template&id=c6ca72ce&scoped=true"
import script from "./NewDBGComponent.vue?vue&type=script&lang=js"
export * from "./NewDBGComponent.vue?vue&type=script&lang=js"
import style0 from "./NewDBGComponent.vue?vue&type=style&index=0&id=c6ca72ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca72ce",
  null
  
)

export default component.exports